import styled from "styled-components";
import { Table } from "react-bootstrap";

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th {
        text-align: center;
    }

    & > tbody.position-data:hover > tr > td {
        background-color: #FFC !important;
        cursor: pointer;
    }

    & > tbody > tr > td {
        text-align: center;
    }

    th.donor {
        background-color: lightsteelblue;
    }

    th.recipient {
        background-color: #063d21;
        color: #FFF;
    }

    & > tbody > tr.backup {
        background-color: #ebe3dd;
    }

    & > tbody > tr.backup > td:nth-child(1),
    & > tbody > tr.backup > td:nth-child(2) {
        background-color: #FFF;
    }

    & > tbody > tr.actual {
        background-color: #cdc7d1;
    }

    & > tbody > tr.actual > td:nth-child(1),
    & > tbody > tr.actual > td:nth-child(2) {
        background-color: #FFF;
    }
`;
